import { motion } from "framer-motion";
import { Twitch, ArrowUpRight } from "lucide-react";
import { FEATURED, PROFILE } from "../data/links";

const EASE = [0.16, 1, 0.3, 1];

export default function Featured() {
  return (
    <section data-testid="featured-section" className="max-w-7xl mx-auto w-full px-4 sm:px-6 py-10 md:py-14">
      <motion.a
        data-testid="featured-twitch-link"
        href={FEATURED.url}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative block border border-white/15 overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src={PROFILE.banner}
            alt="TEZZO"
            className="w-full h-full object-cover opacity-30 grayscale group-hover:opacity-40 group-hover:scale-105 transition-all duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/30" />
        </div>

        <div className="relative p-8 md:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8 min-h-[220px]">
          <div>
            <div className="flex items-center gap-4 mb-2">
              <Twitch className="w-7 h-7 md:w-9 md:h-9" strokeWidth={1.5} />
              <h2 className="font-gothic text-4xl md:text-6xl leading-none">Twitch</h2>
            </div>
            <p className="font-mono-t text-white/50 text-sm tracking-[0.15em]">{FEATURED.note}</p>
          </div>

          <div className="flex items-center gap-4 self-start md:self-center">
            <span className="font-sync text-xs tracking-[0.3em] uppercase text-white/70">WATCH</span>
            <span className="w-12 h-12 border border-white/40 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors duration-200">
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-200" strokeWidth={1.5} />
            </span>
          </div>
        </div>
      </motion.a>
    </section>
  );
}
